import { render, staticRenderFns } from "./editWork.vue?vue&type=template&id=1674a665&scoped=true"
import script from "./editWork.vue?vue&type=script&lang=js"
export * from "./editWork.vue?vue&type=script&lang=js"
import style0 from "./editWork.vue?vue&type=style&index=0&id=1674a665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1674a665",
  null
  
)

export default component.exports